// src/hooks/usePageTracking.js
//
// Per-user page history: users/{uid}/pageLogs.
//
// This is the ONLY writer of that collection. logPageView() used to write it
// too, which double-counted every page that called it. See logPageView.js.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { shouldLog } from "../utils/pageLogDedupe";

export default function usePageTracking() {
  const location = useLocation();
  const auth = getAuth();
  const db = getFirestore();

  const uid = auth.currentUser?.uid;
  const path = location.pathname || "/";

  useEffect(() => {
    if (!uid) return;
    if (path === "/login") return;

    // Module-level guard — survives the StrictMode remount that a component
    // ref would not.
    if (!shouldLog(`log:${uid}:${path}`)) return;

    addDoc(collection(db, "users", uid, "pageLogs"), {
      userId: uid,
      path,
      title: document?.title || "",
      referrer: document?.referrer || "",
      device: navigator?.userAgent || "",
      ts: serverTimestamp(),
    }).catch((err) => {
      console.warn("Page log not written:", err?.message || err);
    });
  }, [db, uid, path]);
}
